import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import FlightRow from "./FlightRow";
import FlightRowLazyLoad from "./FlightRowLazyLoad";
import { BusCardV1, BusCardV2 } from "./BusCard";
import { outputFilteredFlights, $ } from "../shared/utils";
import getPlaces from "../shared/nearby-places-api";
import busRoutes from "../shared/bus-routes.json";
import { CookieTypes, getCookie } from "../shared/cookie";

function normalizeString(str) {
	let normalized = str;
	if (str && str.normalize) {
		normalized = normalized.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	}
	return normalized;
}

function getClickBusURLFor(route, outboundDate, inboundDate) {
	if (!route) {
		return null;
	}

	const [cityOrigem, stateOrigem] = route.origem.split(","); //?
	const [cityDestino, stateDestino] = route.destino.split(","); //?

	let stateOrigemNormalized = stateOrigem.toLowerCase().trim();
	let stateDestinoNormalized = stateDestino.toLowerCase().trim();

	const cityOrigemSlug = cityOrigem
		.trim()
		.toLowerCase()
		.split(" ")
		.join("-");
	const cityDestinoSlug = cityDestino
		.trim()
		.toLowerCase()
		.split(" ")
		.join("-");

	const allowedCitiesWithTodos = ["sao-paulo", "rio-de-janeiro"];
	if (allowedCitiesWithTodos.includes(cityOrigemSlug)) {
		stateOrigemNormalized += "-todos";
	}
	if (allowedCitiesWithTodos.includes(cityDestinoSlug)) {
		stateDestinoNormalized += "-todos";
	}

	let url = `https://www.clickbus.com.br/onibus/${cityOrigemSlug}-${stateOrigemNormalized}/${cityDestinoSlug}-${stateDestinoNormalized}?departureDate=${outboundDate}`;
	if (inboundDate) {
		url += `&returnDate=${inboundDate}`;
	}

	return url;
}

class FlightsList extends Component {
	constructor(...args) {
		super(...args);
		this.handleClickOutside = this.handleClickOutside.bind(this);

		const checkoutIdVisited = getCookie("checkout-visited", CookieTypes.FUNCTIONAL);

		this.state = {
			isLoadingCities: true,
			checkoutIdVisited
		};
	}

	componentDidMount() {
		document.addEventListener("mouseup", this.handleClickOutside);
		this.setCityFromIATASearched();
	}

	componentWillUnmount() {
		document.removeEventListener("mouseup", this.handleClickOutside);
	}

	setCityFromIATASearched = () => {
		const { searchParams } = this.props;

		function findRouteFor(fromCity, toCity) {
			let normalizedFromCity = normalizeString(fromCity);
			let normalizedToCity = normalizeString(toCity);
			const findForFrom = new RegExp(normalizedFromCity, "gmi");
			const findForTo = new RegExp(normalizedToCity, "gmi");

			return busRoutes.find(
				r =>
					findForFrom.test(normalizeString(r.origem)) && findForTo.test(normalizeString(r.destino))
			);
		}

		const filterByIatasOr = iata => place => {
			return place.type === "iata" || place.iata.toLowerCase() === iata.toLowerCase();
		};
		function filterByBR(place) {
			return place.country === "BR";
		}
		function mapByCityName(place) {
			return place.city;
		}

		const getCityFromIATAPromises = [];

		getCityFromIATAPromises.push(
			getPlaces(searchParams.params.from)
				.then(result => result.data)
				.then(result => result.filter(filterByIatasOr(searchParams.params.from)))
				.then(result => result.filter(filterByBR))
				.then(result => result.map(mapByCityName))
		);
		getCityFromIATAPromises.push(
			getPlaces(searchParams.params.to)
				.then(result => result.data)
				.then(result => result.filter(filterByIatasOr(searchParams.params.to)))
				.then(result => result.filter(filterByBR))
				.then(result => result.map(mapByCityName))
		);

		const self = this;

		Promise.all(getCityFromIATAPromises).then(([fromCities, toCities]) => {
			const [fromCity] = fromCities;
			const [toCity] = toCities;
			const busRoute = fromCity && toCity && findRouteFor(fromCity, toCity);
			const clickBusURL = getClickBusURLFor(
				busRoute,
				searchParams.params.outboundDate,
				searchParams.params.inboundDate
			);
			self.setState({ isLoadingCities: false, busRoute, clickBusURL });
		});
	};

	handleClickOutside(event) {
		if (event.target.classList.contains("tooltip")) return;

		const popoverOpened = $(".popover-wrapper:not(.hidden)");

		if (popoverOpened) {
			popoverOpened.classList.add("hidden");
		}
	}

	outputLazyLoadFlightRows() {
		if (this.canShowLazyLoad()) {
			const mockedArr = ["mocked", "flightrow", "just", "for", "layout purposes"];
			return mockedArr.map((item, i) => <FlightRowLazyLoad key={"mocked-item-" + i} />);
		}
	}

	outputFlights(stretch) {
		if (this.canShowLazyLoad()) return null;

		const currentStretch = this.props.currentStretch;
		const selectedFlight = this.props.selectedFlights[stretch];

		const { isLoadingCities, busRoute, clickBusURL, checkoutIdVisited } = this.state;

		const searchFinished = this.props.searchProgress >= 100;

		if (currentStretch == stretch && this.props.flights[stretch].length <= 0 && searchFinished) {
			return (
				<div>
					<h4 className="text-center">Não foi possível encontrar voos para esse trecho.</h4>
				</div>
			);
		}

		if (currentStretch == stretch && selectedFlight.length == 0) {
			let flights = outputFilteredFlights(
				this.props.flights[stretch],
				this.props.selectedFilters[stretch],
				this.props.orderBy[stretch]
			);

			if (flights.length === 0) {
				return (
					<div className="alert alert-warning" role="alert">
						<div className="alert--icon">
							<i className="icon-pin" />
						</div>
						<div className="alert--message">
							<p>Não foi possível encontrar voos com os filtros selecionados.</p>
						</div>
					</div>
				);
			}

			this.isBusCardV1Enabled = !!window.FEATURE_BUSCARDV1;
			this.isBusCardV2Enabled = !!window.FEATURE_BUSCARDV2;
			this.isAnyBusCardEnabled = this.isBusCardV1Enabled || this.isBusCardV2Enabled;
			this.isBusCardBackCheckoutEnabled =
				this.isAnyBusCardEnabled && !!window.FEATURE_BUSCARDBACKCHECKOUT;

			const shouldDisplayBusCardAtFirst = this.isBusCardBackCheckoutEnabled && checkoutIdVisited;
			const hasBusRouteOrLoading = (!isLoadingCities && busRoute) || isLoadingCities;
			let displayIndexBusCard = flights.length > 3 ? 2 : flights.length - 1;
			displayIndexBusCard = shouldDisplayBusCardAtFirst ? 0 : displayIndexBusCard;

			return (
				<div>
					{flights.map((flight, i) => {
						return (
							<Fragment key={flight.id + stretch + i}>
								{i === displayIndexBusCard && this.isAnyBusCardEnabled && (
									<>
										{hasBusRouteOrLoading && (
											<h3 className="head-bus">Confira também passagem de ônibus</h3>
										)}
										{hasBusRouteOrLoading && (
											<>
												{this.isBusCardV1Enabled && (
													<BusCardV1
														href={clickBusURL}
														target="_blank"
														data-action={`bus-buy-${currentStretch}`}
														route={busRoute}
													/>
												)}

												{this.isBusCardV2Enabled && (
													<BusCardV2
														href={clickBusURL}
														target="_blank"
														data-action={`bus-buy-${currentStretch}`}
														route={busRoute}
													/>
												)}
											</>
										)}
										{hasBusRouteOrLoading && <h3 className="head-bus">Outros voos</h3>}
									</>
								)}

								<FlightRow flightdata={flight} childId={flight.id + stretch + i + Math.random()} />
							</Fragment>
						);
					})}
				</div>
			);
		}

		return null;
	}

	outputSelectedFlight(stretch) {
		if (this.canShowLazyLoad()) return null;

		const currentStretch = this.props.currentStretch;
		const selectedFlights = this.props.selectedFlights[stretch];

		if (currentStretch == stretch && selectedFlights.length > 0) {
			return (
				<div>
					{selectedFlights.map((flight, i) => (
						<FlightRow
							flightdata={flight}
							key={Date.now() + flight.direction + stretch}
							isSelectedFlight={true}
						/>
					))}
				</div>
			);
		}
	}

	canShowLazyLoad() {
		return this.props.showLazyLoad || (this.props.searchPartLoading && this.props.isInternational);
	}

	render() {
		return (
			<div>
				{this.outputLazyLoadFlightRows()}
				{this.outputFlights("outbound")}
				{this.outputFlights("inbound")}

				{this.outputSelectedFlight("outbound")}
				{this.outputSelectedFlight("inbound")}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	flights: state.flights,
	orderBy: {
		inbound: state.flights.orderBy.inbound,
		outbound: state.flights.orderBy.outbound
	},
	searchParams: state.searchParams,
	showLazyLoad: state.searchStatus.progress < 45 && state.flights.flightsFound === 0,
	selectedFlights: state.selectedFlights,
	currentStretch: state.flightsTab.currentStretch,
	selectedFilters: state.selectedFilters,
	searchProgress: state.searchStatus.progress,
	searchPartLoading: state.searchStatus.partLoading,
	isInternational: state.searchStatus.isInternational
});

const mapDispatchToProps = dispatch => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FlightsList);
